import useGlobalTranslations from '@/hooks/use-global-translations';
import { Rules }             from '@/helpers/validators.types';

export const blankValidator = (errorMessage: string): Function => (rule: Rules, value: string, callback: (error?: Error) => void) => {
  const wsRegex = /^\s+|\s+$/g;
  if (wsRegex.test(value)) {
    callback(new Error(errorMessage));
  } else {
    callback();
  }
};

export const checkIfPropDeclaredTypeOrNull = <T>(value: T | null, expectedValueType: string): boolean => typeof value === expectedValueType || value === null;

export const containWhitespacesValidator = (errorMessage: string = useGlobalTranslations('rules.whiteSpaces')
  .toString()) => (rule: Rules, value: string, callback: (error?: Error) => void) => {
  const regex = /\s/;
  if (regex.test(value)) {
    callback(new Error(errorMessage));
  } else {
    callback();
  }
};

export const loginValidator = (errorMessage: string): Function => (rule: Rules, value: string, callback: (error?: Error) => void) => {
  const regex = /\s/;

  if (regex.test(value)) {
    callback(new Error(errorMessage));
  } else {
    callback();
  }
};

export const emailValidator = (rule: Rules, value: string, callback: (error?: Error) => void) => {
  // eslint-disable-next-line
  const regex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/;
  if (!regex.test(value)) {
    callback(new Error(useGlobalTranslations('rules.emailPattern') as string));
  } else {
    callback();
  }
};

export function loginCharsValidator(errorMessage: string = useGlobalTranslations('rules.loginPattern', [ '{ a-z }', '{ 0-9 }', '{  . , - , _ , @  }' ])
  .toString()) {
  return (rule: Rules, value: string, callback: (error?: Error) => void) => {
    // eslint-disable-next-line
    const regexp = RegExp('^[\\p{Ll}0-9\.#_@-]+$', 'u');

    if (!regexp.test(value)) {
      callback(new Error(errorMessage));
    } else {
      callback();
    }
  };
}
